

import "./aesthetic.css";

import Header from "../../../components/Header";    
import Footer from "../../../components/Footer";

import { useState, useEffect, useTransition, useRef } from "react";

/* banco de dados */
import { db } from "../../../services/firebaseConnection";
import { collection, addDoc, doc, updateDoc, query, where, getDoc, getDocs, limit } from "firebase/firestore";

import { useForm } from "react-hook-form";

/* redux */
import { useDispatch, useSelector } from "react-redux";
import { updateAgent } from "../../../redux/agent/slice";

/* navegação */
import { useNavigate } from "react-router-dom";

/* validação de campos */
import { masktelefone, maskcep, maskdata } from "../../../services/masks/masks.ts";

/* funções auxiliares */
import { registerLog, showError, clearError, formError, isValidDate, dateToTimestamp, formatTimestamp, wait, firstName } from "../../../services/functions/functions.ts";

/* imagens */
import icon_success from "../../../assets/sucesso.png";
import icon_exclude from "../../../assets/excluir.png";

/* uuis automáticos*/
import { v4 as uuidv4 } from "uuid";

/* envio de email */
import { templateConfigureAgent } from "../../../services/emails/templates.js";


export default function Aesthetic() {

    /*
    1 - dados do atendiemento
    2 - dados do profissional e consulta
    3 - procedimentos
    4 - agenda
    5 - finalizar
    */

    const [step, setStep] = useState(0);
    const [error, setError] = useState("0");
    const [telefone, setTelefone] = useState("");

    const [load, setLoad] = useState(true);

    const [cursos, setCursos] = useState([]);
    const [procedimentos, setProcedimentos] = useState([]);
    const [faq, setFaq] = useState([]);
    const [blocks, setBlocks] = useState([]);
    const [agenda, setAgenda] = useState(Array.from({ length: 7 * 24 }, (_, index) => { const dia = Math.floor(index / 24); const hora = index % 24; return { dia, hora, disponivel: false }; }));

    /* referências para tratativa de erros */
    //tela 1 - clinica
    const refDescription = useRef(null);
    const refLabelDescription = useRef(null);
    const refErrorDescription = useRef(null);

    const refCep = useRef(null);
    const refLabelCep = useRef(null);
    const refErrorCep = useRef(null);

    const refLogradouro = useRef(null);
    const refLabelLogradouro = useRef(null);
    const refErrorLogradouro = useRef(null);

    const refNumero = useRef(null);
    const refLabelNumero = useRef(null);

    const refMunicipio = useRef(null);
    const refLabelMunicipio = useRef(null);
    const refErrorMunicipio = useRef(null);

    const refUf = useRef(null);
    const refLabelUf = useRef(null);

    const refSite = useRef(null);
    const refLabelSite = useRef(null);
    const refErrorSite = useRef(null);

    const refInsta = useRef(null);
    const refLabelInsta = useRef(null);

    const refTelefone = useRef(null);
    const refLabelTelefone = useRef(null);
    const refErrorTelefone = useRef(null);

    //tela 2 - esteticista
    const refEsteticista = useRef(null);
    const refLabelEsteticista = useRef(null);
    const refErrorEsteticista = useRef(null);

    const refInformacao = useRef(null);
    const refLabelInformacao = useRef(null);
    const refErrorInformacao = useRef(null);

    const refCurso = useRef(null);
    const refLabelCurso = useRef(null);
    const refErrorCurso = useRef(null);

    const refConclusao = useRef(null);
    const refLabelConclusao = useRef(null);

    //tela 3 - procedimentos
    const refProcedimentos = useRef(null);
    const refLabelProcedimentos = useRef(null);
    const refErrorProcedimentos = useRef(null);

    const refValorProcedimentos = useRef(null);
    const refLabelValorProcedimentos = useRef(null);

    const refProcedimentosDescricao = useRef(null);
    const refLabelProcedimentosDescricao = useRef(null);
    const refErrorProcedimentosDescricao = useRef(null);

    const refPergunta = useRef(null);
    const refLabelPergunta = useRef(null);
    const refErrorPergunta = useRef(null);

    const refResposta = useRef(null);
    const refLabelResposta = useRef(null);
    const refErrorResposta = useRef(null);

    const refErroProcedimento = useRef(null);

    //tela 4 - calendário
    const refErrorAgenda = useRef(null);
    const refButtonConcluir = useRef(null);

    const refDiaInicial = useRef(null);
    const refLabelDiaInicial = useRef(null);
    const refErrorDiaInicial = useRef(null);

    const refDiaFinal = useRef(null);
    const refLabelDiaFinal = useRef(null);

    const refMotivo = useRef(null);
    const refLabelMotivo = useRef(null);

    const refCheckBox = useRef(null);
    const refErrorTerms = useRef(null);

    const refError = useRef(null);
    /* --- */

    const { user } = useSelector((rootReducer) => rootReducer.user);
    const { agent } = useSelector((rootReducer) => rootReducer.agent);

    const { handleSubmit, register, setValue, getValues, watch } = useForm();

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const [isPending, startTransition] = useTransition();

    const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms));

    const dias = Array.from({ length: 7 }, (_, d) => agenda.filter(item => item.dia === d));

    const marcar_agenda = (dia, hora) => {setAgenda(prev => prev.map(item => item.dia === dia && item.hora === hora ? {...item, disponivel: !item.disponivel} : item)); refErrorAgenda.current.innerHTML = ""; refErrorAgenda.current.style.height = "0";};

    useEffect(() => { window.scrollTo(0, 0); }, []);


    useEffect(() => {

        async function loadclient() {

            try {

                setValue("empresa", user.empresa);
                setValue("numero_consultas", 0);

                //adicionar rotina para alteração de agente, status = 4

                setLoad(false);

            }
            catch(erro) {
                alert(erro);
            }

        }

        loadclient();

    }, [])
    


    function aesthetic_step1(e) {

        e.preventDefault();

        let ds = getValues("description");
        if(ds.length < 10) {
            showError(refDescription, refLabelDescription, refErrorDescription, "Insira alguma descrição para que seu agente atue melhor", setError, "description");
            return;
        }

        let cp = getValues("cep");
        if(cp.length < 9) {
            showError(refCep, refLabelCep, refErrorCep, "Insira um CEP com oito caracteres", setError, "cep");
            return;
        }

        let lg = getValues("logradouro");
        if(lg.length < 5) {
            showError(refLogradouro, refLabelLogradouro, refErrorLogradouro, "Insira o logradouro do endereço", setError, "logradouro");
            return;
        }

        let nu = getValues("numero");
        if(nu.length === 0) {
            showError(refNumero, refLabelNumero, refErrorLogradouro, "Insira o número do logradouro do endereço", setError, "numero");
            return;
        }

        let mu = getValues("municipio");
        if(mu.length < 3) {
            showError(refMunicipio, refLabelMunicipio, refErrorMunicipio, "Insira o nome do Município do endereço", setError, "municipio");
            return;
        }

        let uf = getValues("uf");
        if(uf.length < 2) {
            showError(refUf, refLabelUf, refErrorMunicipio, "Insira a sigla da UF do endereço", setError, "uf");
            return;
        }

        let st = getValues("site");
        if(st.length > 0) {
            const rsite = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/.*)?$/i;
            if(!rsite.test(st)) {
                showError(refSite, refLabelSite, refErrorSite, "Insira uma URL de web site válida", setError, "site");
                return;
            }
        }

        let ig = getValues("instagram");
        if(ig.length > 0 && ig === "@") {
            showError(refInsta, refLabelInsta, refErrorSite, "Esse endereço de Instagram não é válido", setError, "instagram");
            return;
        }

        let tl = getValues("telefone_humano");
        if(tl.length > 0 && tl.length < 15) {
            showError(refTelefone, refLabelTelefone, refErrorTelefone, "Número de telefone incorreto, insira DDD + telefone", setError, "telefone_humano");
            return;
        }

        registerLog(user.id, "/configure_agent/step1/id=" + agent.id);

        setStep(1);
        window.scrollTo(0, 0);

    }



    function aesthetic_step2(e) {

        e.preventDefault();

        let pr = getValues("esteticista");
        const v_nome = (nome) => { let validade = /\b[A-Za-zÀ-ú][A-Za-zÀ-ú]+,?\s[A-Za-zÀ-ú][A-Za-zÀ-ú]{2,19}\b/gi; return validade.test(nome); }
        if(!v_nome(pr)) {
            showError(refEsteticista, refLabelEsteticista, refErrorEsteticista, "Insira o nome completo do(a) esteticista", setError, "esteticista");
            return;
        }
        
        let im = getValues("informacao");
        if(im.length < 10) {
            showError(refInformacao, refLabelInformacao, refErrorInformacao, "Insira alguma informação ou fato relevante para que seu agente atue melhor", setError, "informacao");
            return;
        }
        
        registerLog(user.id, "/configure_agent/step2/id=" + agent.id);

        setStep(2);
        window.scrollTo(0, 0);

    }



    function aesthetic_step3() {

        formError(refErroProcedimento, "", false);

        if(procedimentos.length === 0) {
            formError(refErroProcedimento, "Você deve inserir no mínimo um procedimento para continuar", true);
            return;
        }

        registerLog(user.id, "/configure_agent/step3/id=" + agent.id);
        setStep(3);
        window.scrollTo(0, 0);

    }



    async function configure_agent(data) {

        formError(refError, "", false);

        const dsp = agenda.some(item => item.disponivel);
        if(dsp === false) {
            refErrorAgenda.current.innerHTML = "Você precisa selecionar ao menos um dia-horário para continuar.";
            refErrorAgenda.current.style.height = "1.5rem";
            return
        }

        if(!refCheckBox.current.checked) {
            refErrorTerms.current.innerHTML = "Para concluir você precisa aceitar nossos termos de uso.";
            refErrorTerms.current.style.height = "1.5rem";
            return;
        }

        startTransition( async() => {

        try {

            let uid = user.id;
            let aid = agent.id;
            let apl = agent.plano;
            
            refButtonConcluir.current.innerText = "AGUARDE ... registrando dados";
            
            //registra os dados
            let dt_atual = new Date();
            
            await addDoc(collection(db, "aesthetic"), 
            { 
                id_client: uid,
                id_agent: aid,
                codigo_plano: apl,
                data_criacao: dt_atual,
                data_inicio_vigencia: dt_atual,
                data_termino_vigencia: new Date("2100-12-31T23:59:59Z"),
                empresa: data.empresa,
                descricao: data.description,
                cep: data.cep,
                logradouro: data.logradouro,
                numero: data.numero,
                complemento: data.complemento,
                bairro: data.bairro,
                municipio: data.municipio,
                uf: data.uf,
                site: data.site,
                instagram: data.instagram,
                telefone_humano: data.telefone_humano,
                esteticista: data.esteticista,
                informacao: data.informacao,
                cursos: cursos,                
                procedimentos: procedimentos,
                faq: faq,
                agenda: agenda,
                bloqueios: blocks,
            })
            
            await wait(500);

            refButtonConcluir.current.innerText = "AGUARDE ... verificando disponibilidade";

            //verifica qual linha está disponível
            const telephonedb = collection(db, "telephones");
            const telephonequery = query(telephonedb, where("status", "==", 1), limit(1));

            const telephonedoc = await getDocs(telephonequery);
            if(telephonedoc.size === 0) {
                
                //sem linha disponível
                const agentref = doc(db, "agents", aid);
                await updateDoc(agentref, { status: 2, status_motivo: "não há linha disponivel"});

                //atualiza sessão e redux
                sessionStorage.setItem('status', JSON.stringify(2));

                dispatch(updateAgent({
                    id: agent.id,
                    nome: agent.nome,
                    plano: agent.plano,
                    status: 2,
                }))

                alert("não há linha disponível");

                //atualiza a tela e informa ao cliente

            }
            else {
                
                let idtel = telephonedoc.docs[0].id;
                let tel = telephonedoc.docs[0].data().telefone;
                let idgpt = telephonedoc.docs[0].data().id_gptmaker;
                let idagd = telephonedoc.docs[0].data().id_agenda;

                await wait(500);
                refButtonConcluir.current.innerText = "AGUARDE ... alocando linha";

                const mk_ln = await make_line(idtel);

                if(mk_ln.error) {

                    //atualiza a tela e informa ao cliente
                    alert(mk_ln.description);
                    return;

                }

                setTelefone(tel);

                await wait(500);

                const up_ag = await update_agent(agent.id, dt_atual, idtel, tel);

                if(up_ag.error) {

                    //atualiza a tela e informa ao cliente
                    alert(up_ag.description);
                    return;

                }
                
                await wait(500);

                refButtonConcluir.current.innerText = "AGUARDE ... configurando agente";
                
                const cr_ag = await create_agentgpt(idgpt);
                
                if(cr_ag.error) {

                    //atualiza a tela e informa ao cliente
                    alert(cr_ag.description);
                    return;

                };
                
                await wait(500);

                const tr_ag = await add_treinamentos(idgpt);

                if(tr_ag.error) {

                    //atualiza a tela e informa ao cliente
                    alert(tr_ag.description);
                    return;

                };

                refButtonConcluir.current.innerText = "AGUARDE ... compartilhando agenda";

                const sh_cl = await share_calendar(idagd, user.email);
                
                if(sh_cl.error) {

                    //atualiza a tela e informa ao cliente
                    alert(sh_cl.description);
                    return;

                };

                await wait(500);
                
                //envia email ao cliente
                let pnm = firstName(user.nome);
                let agn = agent.nome;
                let eml = user.email;

                const resEmailConfigAgent = await fetch("https://google-services-712108985873.southamerica-east1.run.app/send-email", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        to: eml,
                        subject: "Agente Criado e Configurado",
                        html: templateConfigureAgent({nome: pnm, agente: agn, telefone: tel}),
                    }),
                });
                
                const dataEmailConfigAgent = await resEmailConfigAgent.json();
                if(dataEmailConfigAgent.status !== "ok") {
                    alert("envio email: " + dataEmailConfigAgent.message);
                    return;
                }

                await wait(500);

                registerLog(user.id, "/configure_agent/success/id=" + agent.id);
                setStep(4);
                window.scrollTo(0, 0);
                
            }
            
        } 
        catch(erro) {
            formError(refError, "Principal: " + erro, true);
        }
        finally {
            refButtonConcluir.current.innerText = "CONCLUIR";
        }
        })
        
    }



    async function add_treinamentos(id_agent_gptmaker) {

        try {
            
            //treinamento: agenda
            const dias = ["Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado", "Domingo"];
            
            let textoFinal = "";

            dias.forEach((diaNome, diaIndex) => {
                const horarios = agenda
                    .filter(item => item.dia === diaIndex && item.disponivel)
                    .map(item => `${String(item.hora).padStart(2, "0")}:00`);

                textoFinal += diaNome + ":\n";

                if (horarios.length === 0) {
                    textoFinal += "Não disponível\n\n";
                } else {
                    textoFinal += horarios.join("\n") + "\n\n";
                }
            });

            let agn = "## AGENDA:\n" + textoFinal.trim();
            
            const resGptMakerAgenda = await fetch("https://gptmaker-services-712108985873.southamerica-east1.run.app/treinamento/add", 
            {
                method: "POST", headers: { "Content-Type": "application/json" },

                body: JSON.stringify({
                    id: id_agent_gptmaker,
                    texto: agn
                })
            });
           
            if(resGptMakerAgenda.status !== 200) {
                return { error: true, description: resGptMakerAgenda.error };
            }
            
            await wait(500);

            //treinamento: dias bloqueados
            let blc = "";
            blocks.map((item) => {
                blc += item.dia_final === null ? formatTimestamp(item.dia_inicial) + " - " + item.motivo + "\n" : formatTimestamp(item.dia_inicial) + " a " + formatTimestamp(item.dia_final) + " - " + item.motivo + "\n";
            })

            blc = "## DIAS BLOQUEADOS:\n" + blc;
            
            const resGptMakerBlocks = await fetch("https://gptmaker-services-712108985873.southamerica-east1.run.app/treinamento/add", 
            {
                method: "POST", headers: { "Content-Type": "application/json" },

                body: JSON.stringify({
                    id: id_agent_gptmaker,
                    texto: blc
                })
            });
        
            if(resGptMakerBlocks.status !== 200) {
                return { error: true, description: resGptMakerBlocks.error };
            }
            
            await wait(500);

            //treinamento: endereço e redes sociais
            let edr = "## ENDEREÇO:\n" + getValues("logradouro") + "\nNúmero: " + getValues("numero") + "\nBairro: " + getValues("bairro") + (getValues("complemento").length > 0 ? "\nComplemento: " + getValues("complemento") : "") + "\nMunicípio: " + getValues("municipio") + " - " + getValues("uf") + "\nCEP: " + getValues("cep");

            if(getValues("site").length > 0 || getValues("instagram").length > 0) {
                
                edr = edr + "\n\n## REDES SOCIAIS:" + (getValues("site").length > 0 ? "\nWeb Site: " + getValues("site") : "") + (getValues("instagram").length > 0 ? "\nInstagram: " + getValues("instagram") : "");

            }
            
            const resGptMakerEndereco = await fetch("https://gptmaker-services-712108985873.southamerica-east1.run.app/treinamento/add", 
            {
                method: "POST", headers: { "Content-Type": "application/json" },

                body: JSON.stringify({
                    id: id_agent_gptmaker,
                    texto: edr
                })
            });
        
            if(resGptMakerEndereco.status !== 200) {
                return { error: true, description: resGptMakerEndereco.error };
            }
            
            await wait(500);

            //treinamento: cursos
            if(cursos.length > 0) {

                let crs = "";

                cursos.map((item) => {
                    crs += item.descricao.length > 0 ? "Nome do Curso: " + item.curso + "\nAno de Conclusão: " + item.conclusao + "\nDescrição: " + item.descricao + "\n\n" : "Nome do Curso: " + item.curso + "\nAno de Conclusão: " + item.conclusao + "\n\n";
                })

                crs = "## CURSOS:\n" + crs;

                const resGptMakerCursos = await fetch("https://gptmaker-services-712108985873.southamerica-east1.run.app/treinamento/add", 
                {
                    method: "POST", headers: { "Content-Type": "application/json" },

                    body: JSON.stringify({
                        id: id_agent_gptmaker,
                        texto: crs
                    })
                });
           
                if(resGptMakerCursos.status !== 200) {
                    return { error: true, description: resGptMakerCursos.error };
                }
            
            }

            await wait(500);

            //treinamento: procdimentos
            let prc = "";

            procedimentos.map((item) => {
                prc += item.descricao.length > 0 ? "Nome do Procedimento: " + item.procedimento + "\nValor do Procedimento: R$ " + item.valor.toFixed(2, 0) + "\nDescrição: " + item.descricao + "\n\n" : "Nome do Procedimento: " + item.procedimento + "\nValor do Procedimento: R$ " + item.valor.toFixed(2, 0) + "\n\n";
            })

            prc = "## PROCEDIMENTOS:\n" + prc;

            if(faq.length > 0) {

                let fqs = "";

                faq.map((item) => {
                    fqs += "Pergunta: " + item.pergunta + "\nResposta: " + item.resposta + "\n\n";
                })

                prc = prc + "\n\n## FAQ:\n" + fqs;

            }

            const resGptMakerProcedimento = await fetch("https://gptmaker-services-712108985873.southamerica-east1.run.app/treinamento/add", 
            {
                method: "POST", headers: { "Content-Type": "application/json" },

                body: JSON.stringify({
                    id: id_agent_gptmaker,
                    texto: prc
                })
            });
        
            if(resGptMakerProcedimento.status !== 200) {
                return { error: true, description: resGptMakerProcedimento.error };
            }            

            await wait(500);

            return { error: false, description: "" };
            
        }
        catch(erro) {
            return { error: true, description: erro };
        }
        
    }



    async function make_line(idtel) {

        try {

            const telephoneref = doc(db, "telephones", idtel);
            await updateDoc(telephoneref, { status: 2 });

            return { error: false, description: "" };

        } 
        catch (erro) {
            return { error: true, description: "make_line " + erro };
        }

    }



    async function update_agent(idagent, dt_atual, idtel, tel) {
        
        try {
        
            const agentref = doc(db, "agents", idagent);
            await updateDoc(agentref, { data_inicio_ativacao: dt_atual, data_termino_ativacao: new Date("2100-12-31T23:59:59Z"), status: 3, telefone: tel })

            const dagent = await getDoc(agentref);

            let id_client = dagent.data().id_client;
            let plano = dagent.data().plano;

            await addDoc(collection(db, "uses"), 
            { 
                id_client: id_client,
                id_agent: idagent,
                id_telephone: idtel,
                plano: plano,
                data_criacao: dt_atual,
                data_inicio_vigencia: dt_atual,
                data_termino_vigencia: new Date("2100-12-31T23:59:59Z"),
            })

            sessionStorage.setItem('status', JSON.stringify(3));

            dispatch(updateAgent({
                id: agent.id,
                nome: agent.nome,
                plano: agent.plano,
                status: 3,
            }))

            return { error: false, description: "" };

        }
        catch(erro) {
            return { error: true, description: "erro update_agent " + erro };
        }

    }


    async function create_agentgpt(idagentgpt) {

        try {

            let prmp01 = "Você é um assistente virtual de atendimento para um esteticista. Sua função é atender pacientes com cordialidade, objetividade e profissionalismo, sempre tentando ajudar prestando informações ou agendando e reagendando procedimentos.";
            let prmp02 = "\n\nPrimeira Mensagem: Olá! Sou o assistente virtual do(a) [NOME]. Como posso te ajudar? Deseja informações ou agendamento de procedimentos?";
            let prmp03 = "\n\nEsteticista:\nNome: " + getValues("esteticista") + "\nEspecializações: " + getValues("informacao");
            let prmp04 = "\n\nATENÇÃO:\nNUNCA faça diagnóstico de doença e nem indique qualquer tipo de medicamento aos pacientes.";

            const prompt = prmp01 + prmp02 + prmp03 + prmp04;
            
            const resGptMaker = await fetch("https://gptmaker-services-712108985873.southamerica-east1.run.app/agent/update", { 
                method: "POST", 
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    id: idagentgpt,
                    name: agent.nome,
                    behavior: prompt,
                    jobname: "Esteticistas",
                    jobdescription: getValues("description")
                })
            });
            
            if(resGptMaker.status === 200) {
                return { error: false, description: "" };
            } 
            
        }
        catch (error) {

            if (error.response) {
                return { error: true, description: "API GptMaker Erro - " + error.response.data };
            } else {
                return { error: true, description: "API GptMaker Falha - " + error.message };
            }
            
        }
 
    }



    async function share_calendar(idagenda, pemail) {
        
        try {

            const resCalendar = await fetch("https://google-services-712108985873.southamerica-east1.run.app/share", { 
                method: "POST", 
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    id_agenda: idagenda,
                    email: pemail
                })
            });
           
            if(resCalendar.status === 200) {
                return { error: false, description: "" };
            } 

        }
        catch (error) {

            if (error.response) {
                return { error: true, description: "API Calendar Erro - " + error.response.data };
            } else {
                return { error: true, description: "API Calendar Falha - " + error.message };
            }

        }

    }


    async function find_address() {

        let cp = getValues("cep");
        if(cp.length < 9) {
            setError("cep");
            setValue("logradouro", "");
            setValue("bairro", "");
            setValue("municipio", "");
            setValue("uf", "");
            showError(refCep, refLabelCep, refErrorCep, "Insira um CEP com oito digitos", setError, "cep");
            return;
        }

        startTransition( async() => {
        try {

            cp = cp.replace('-', '');
            const rcep = await fetch(`https://viacep.com.br/ws/${cp}/json/`);
            
            rcep.json().then(data => {

            if(data.erro === "true") {
                setValue("logradouro", "");
                setValue("bairro", "");
                setValue("municipio", "");
                setValue("uf", "");
                setError("cep");
                showError(refCep, refLabelCep, refErrorCep, "Esse CEP não foi localizado, verifique a digitação", setError, "cep");
            } else {
                setValue("logradouro", data.logradouro);
                setValue("bairro", data.bairro);
                setValue("municipio", data.localidade);
                setValue("uf", data.uf);
                refNumero.current.focus();
            }

            });

        }
        catch(erro) {
            console.log(erro);
        }
        })
        
    }

    function vinsta(e) {
        if (e.length >0 && !e.startsWith("@")) {
            setValue("instagram", "@" + e.replace(/@/g, ""));
        }
    }

    
    function back_step(stp) {

        setStep(stp);
        window.scrollTo(0, 0);

    }
    


    function add_cursos() {

        let cs = getValues("curso");
        if(cs.length < 3) {
            showError(refCurso, refLabelCurso, refErrorCurso, "Você deve inserir um nome para seu curso", setError, "curso");
            return;
        }

        let cc = getValues("conclusao");
        if(cc.length < 4) {
            showError(refConclusao, refLabelConclusao, refErrorCurso, "Insira um ano de conclusão para seu curso", setError, "conclusao");
            return;
        }

        let dc = getValues("descricao_curso");

        setCursos(cr => [...cr, {id: uuidv4(), curso: cs, conclusao: Number(cc), descricao: dc}]);

        setValue("curso", "");
        setValue("conclusao", "");
        setValue("descricao_curso", "");
        refCurso.current.focus();
        
    }


    function remove_cursos(id) {

        setCursos(prev => prev.filter(cursos => cursos.id !== id));

    }



    function add_procedimento() {

        formError(refErroProcedimento, "", false);

        let pc = getValues("procedimento");
        if(pc.length < 3) {
            showError(refProcedimentos, refLabelProcedimentos, refErrorProcedimentos, "Você deve inserir um título para o procedimento", setError, "procedimento");
            return;
        }

        let vp = getValues("valor_procedimento").replace(",", ".");
        if(vp.length === 0 || isNaN(Number(vp))) {
            showError(refValorProcedimentos, refLabelValorProcedimentos, refErrorProcedimentos, "Insira um valor válido em reais para seu procedimento", setError, "exame_procedimento");
            return;
        }

        let dp = getValues("descricao_procedimento");
        if(dp.length < 10) {
            showError(refProcedimentosDescricao, refLabelProcedimentosDescricao, refErrorProcedimentosDescricao, "Insira uma descrição para um melhor entendimento do procedimento", setError, "descricao_procedimento");
            return;
        }

        setProcedimentos(pr => [...pr, {id: uuidv4(), procedimento: pc, valor: Number(vp), descricao: dp}]);

        setValue("procedimento", "");
        setValue("valor_procedimento", "");
        setValue("descricao_procedimento", "");
        refProcedimentos.current.focus();
        
    }


    function remove_procedimento(id) {

        setProcedimentos(prev => prev.filter(procedimentos => procedimentos.id !== id));

    }



    function add_faq() {

        let pg = getValues("pergunta");
        if(pg.length < 5) {
            showError(refPergunta, refLabelPergunta, refErrorPergunta, "Insira uma frase completa como pergunta", setError, "pergunta");
            return;
        }

        let rp = getValues("resposta");
        if(rp.length < 5) {
            showError(refResposta, refLabelResposta, refErrorResposta, "Insira uma frase completa como resposta", setError, "resposta");
            return;
        }

        setFaq(fq => [...fq, {id: uuidv4(), pergunta: pg, resposta: rp}]);

        setValue("pergunta", "");
        setValue("resposta", "");
        refPergunta.current.focus();
        
    }


    function remove_faq(id) {

        setFaq(prev => prev.filter(faq => faq.id !== id));

    }



    function add_block() {

        let di = getValues("dia_inicial");
        if(!isValidDate(di)) {
            showError(refDiaInicial, refLabelDiaInicial, refErrorDiaInicial, "Dia inicial é inválido (formato dd/mm/aa)", setError, "dia_inicial");
            return;
        }

        let df = getValues("dia_final");
        if(df.length > 0) {
            if(!isValidDate(df)) {
                showError(refDiaFinal, refLabelDiaFinal, refErrorDiaInicial, "Dia final é inválido (formato dd/mm/aa)", setError, "dia_final");
                return;
            }
        }

        if(di.length > 0 && df.length > 0) {
            if(dateToTimestamp(df) < dateToTimestamp(di)) {
                showError(refDiaFinal, refLabelDiaFinal, refErrorDiaInicial, "O dia final deve ser maior ou igual ao dia inicial ", setError, "dia_final");
                return;
            }
        }

        let mt = getValues("motivo");
        if(mt.length === 0) {
            showError(refMotivo, refLabelMotivo, refErrorDiaInicial, "Insira um breve motivo para bloquear dias", setError, "motivo");
            return;
        }


        setBlocks(bl => [...bl, {id: uuidv4(), dia_inicial: dateToTimestamp(di), dia_final: df.length > 0 && dateToTimestamp(df) > dateToTimestamp(di) ? dateToTimestamp(df) : null, motivo: mt}]);

        setValue("dia_inicial", "");
        setValue("dia_final", "");
        setValue("motivo", "");
        refDiaInicial.current.focus();
        
    }


    function remove_block(id) {

        setBlocks(prev => prev.filter(blocks => blocks.id !== id));

    }



    function accept_terms() {

        if(refCheckBox.current.checked) {
            refErrorTerms.current.innerHTML = "";
            refErrorTerms.current.style.height = "0rem";
        }

    }


    return(

        <div className="context">
        
            <Header access={1}></Header>
        
            <div className="content">

                { step === 0 && 
                (
                <>
                <div className="ft_topico">Configurar agente</div>
                <div className="ft_descricao">Chegou a hora de configurar seu agente, essa é uma etapa muito importante, aqui você definirá todas as regras para que seu agente possa dar o melhor atendimento a seus clientes.</div>
                <div className="space"></div>

                <div className="border_form aesthetic_border_form">
                    <form className="form">

                        <span className="step_form">
                            <span className="step_form_number">Passo 1/4</span>
                            <span className="step_form_description">&nbsp;. Informações Gerais</span>
                        </span>
                    
                        <span className="space_form"></span>

                        <span className="title_form">Clínica ou local de atendimento</span>
                        <span className="subtitle_form">Informações cadastradas sobre a clínica ou local de atendimento do profissional.</span>
                        
                        <label for="inp" className="inp">
                        <input type="text" placeholder="&nbsp;" {...register("empresa")} disabled={true}></input>
                        <span className="label">Empresa</span>
                        <span className="focus-bg"></span>
                        </label>
                        <span className="space_form"></span>

                        <span className="subtitle_form">Descreva as especialidades da clínica ou local de atendimento e os fatores que você julgue relevantes para que seus clientes saibam.</span>
                        <span className="subtitle_form">O agente fornecerá essas qualificações a seus clientes.</span>
                        
                        <span ref={refErrorDescription} className="error_form"></span>
                        <label for="inp2" className="inp2" ref={refLabelDescription}>
                        <textarea placeholder="&nbsp;" {...register("description")} maxLength={400} ref={(el) => {refDescription.current = el; register("description").ref(el);}} onClick={() => clearError(refDescription, refLabelDescription, refErrorDescription, error, setError)} onChange={() => clearError(refDescription, refLabelDescription, refErrorDescription, error, setError)}></textarea>
                        <span class="label2">Especialidades e pontos relevantes</span>
                        <span class="focus-bg2"></span>
                        </label>
                        <span className="space_form"></span>

                        <span className="title_form">Endereço</span>
                        <span className="subtitle_form">O agente fornecerá sempre que perguntado o endereço.</span>
                        <span className="aesthetic_observacao">Para facilitar, digite o CEP e clique em "buscar endereço".</span>
                
                        <span ref={refErrorCep} className="error_form"></span>
                        <div className="aesthetic_box01">

                            <div className="aesthetic_box01a">
                                <label for="inp" className="inp" ref={refLabelCep}>
                                <input type="text" placeholder="&nbsp;" maxLength={9} {...register("cep")} onKeyDown={(e) => {if (e.key === "Enter") {find_address();}}} ref={(el) => {refCep.current = el; register("cep").ref(el);}} onClick={() => clearError(refCep, refLabelCep, refErrorCep, error, setError)} onChange={(e) => {if (error === "0") {setValue("cep", maskcep(e.target.value));} else {clearError(refCep, refLabelCep, refErrorCep, error, setError);}}}></input>
                                <span className="label">CEP</span>
                                <span className="focus-bg"></span>
                                </label>
                            </div>

                            <div className="aesthetic_box01b"></div>

                            <div className="aesthetic_box01c">
                                <button type="button" name="bt1" className={ isPending ? "buttonsearch_disabled_form" : "buttonsearch_form" } onClick={ find_address }>{ isPending ? "AGUARDE ..." : "BUSCAR ENDEREÇO" }</button>
                            </div>

                            <div className="aesthetic_box01d"></div>

                        </div>
                        <span className="space_form"></span>

                        <span ref={refErrorLogradouro} className="error_form"></span>
                        <div className="aesthetic_box">

                            <div className="aesthetic_box02a">
                            <label for="inp" className="inp" ref={refLabelLogradouro}>
                            <input type="text" placeholder="&nbsp;" maxLength={60} {...register("logradouro")} ref={(el) => {refLogradouro.current = el; register("logradouro").ref(el);}} onClick={() => clearError(refLogradouro, refLabelLogradouro, refErrorLogradouro, error, setError)} onChange={() => clearError(refLogradouro, refLabelLogradouro, refErrorLogradouro, error, setError)}></input>
                            <span className="label">Logradouro</span>
                            <span className="focus-bg"></span>
                            </label>
                            </div>

                            <div className="aesthetic_box02b"></div>

                            <div className="aesthetic_box02c">
                            <label for="inp" className="inp" ref={refLabelNumero}>
                            <input type="text" placeholder="&nbsp;" maxLength={8} {...register("numero")} ref={(el) => {refNumero.current = el; register("numero").ref(el);}} onClick={() => clearError(refNumero, refLabelNumero, refErrorLogradouro, error, setError)} onChange={() => clearError(refNumero, refLabelNumero, refErrorLogradouro, error, setError)}></input>
                            <span className="label">Número</span>
                            <span className="focus-bg"></span>
                            </label>
                            </div>

                        </div>
                        <span className="space_form"></span>

                        <span ref={refErrorMunicipio} className="error_form"></span>
                        <div className="aesthetic_box">

                            <div className="aesthetic_box02a">
                            <label for="inp" className="inp">
                            <input type="text" id="bairro" placeholder="&nbsp;" maxLength={30} {...register("bairro")}></input>
                            <span className="label">Bairro</span>
                            <span className="focus-bg"></span>
                            </label>
                            </div>

                            <div className="aesthetic_box02b"></div>

                            <div className="aesthetic_box02c">
                            <label for="inp" className="inp">
                            <input type="text" id="complemento" placeholder="&nbsp;" maxLength={15} {...register("complemento")}></input>
                            <span className="label">Complemento</span>
                            <span className="focus-bg"></span>
                            </label>
                            </div>

                        </div>
                        <span className="space_form"></span>

                        <div className="aesthetic_box">

                            <div className="aesthetic_box02a">
                            <label for="inp" className="inp" ref={refLabelMunicipio}>
                            <input type="text" placeholder="&nbsp;" maxLength={30} {...register("municipio")} ref={(el) => {refMunicipio.current = el; register("municipio").ref(el);}} onClick={() => clearError(refMunicipio, refLabelMunicipio, refErrorMunicipio, error, setError)} onChange={() => clearError(refMunicipio, refLabelMunicipio, refErrorMunicipio, error, setError)}></input>
                            <span className="label">Município</span>
                            <span className="focus-bg"></span>
                            </label>
                            </div>

                            <div className="aesthetic_box02b"></div>

                            <div className="aesthetic_box02c">
                            <label for="inp" className="inp" ref={refLabelUf}>
                            <input type="text" placeholder="&nbsp;" maxLength={2} {...register("uf")} ref={(el) => {refUf.current = el; register("uf").ref(el);}} onClick={() => clearError(refUf, refLabelUf, refErrorMunicipio, error, setError)} onChange={() => clearError(refUf, refLabelUf, refErrorMunicipio, error, setError)}></input>
                            <span className="label">UF</span>
                            <span className="focus-bg"></span>
                            </label>
                            </div>
                            
                        </div>
                        <span className="space_form"></span>

                        <span className="title_form">Web site e redes sociais</span>
                        <span className="subtitle_form">O agente poderá fornecer sempre que perguntado o web site e a rede social da clínica.</span>
                
                        <span ref={refErrorSite} className="error_form"></span>
                        <div className="aesthetic_box">

                            <div className="aesthetic_box02a">
                            <label for="inp" className="inp" ref={refLabelSite}>
                            <input type="text" id="site" placeholder="&nbsp;" maxLength={50} {...register("site")} ref={(el) => {refSite.current = el; register("site").ref(el);}} onClick={() => clearError(refSite, refLabelSite, refErrorSite, error, setError)} onChange={() => clearError(refSite, refLabelSite, refErrorSite, error, setError)}></input>
                            <span className="label">Web Site</span>
                            <span className="focus-bg"></span>
                            </label>
                            </div>

                            <div className="aesthetic_box02b"></div>

                            <div className="aesthetic_box02c">
                            <label for="inp" className="inp" ref={refLabelInsta}>
                            <input type="text" placeholder="&nbsp;" maxLength={30} {...register("instagram")} ref={(el) => {refInsta.current = el; register("instagram").ref(el);}} onClick={() => clearError(refInsta, refLabelInsta, refErrorSite, error, setError)} onChange={(e) => {if (error === "0") {vinsta(e.target.value);} else {clearError(refInsta, refLabelInsta, refErrorSite, error, setError);}}}></input>
                            <span className="label">Instagram</span>
                            <span className="focus-bg"></span>
                            </label>
                            </div>

                        </div>
                        <span className="space_form"></span>

                        <span className="title_form">Transferência para humano</span>
                        <span className="subtitle_form">Em determinadas situções o agente pode não ter a resposta ou a informação necessária, ou simplesmente possa surgir algum tema sensível onde ele poderá direcionar a chamada a um humano para que possa dar um tratamento mais adequado ao paciente.</span>
                        <span className="subtitle_form">Número a ser transferido:</span>

                        <span ref={refErrorTelefone} className="error_form"></span>
                        <div className="aesthetic_box">
                            <div className="aesthetic_box03a">
                                <label for="inp" className="inp" ref={refLabelTelefone}>
                                <input type="text" placeholder="&nbsp;" maxLength={15} {...register("telefone_humano")} ref={(el) => {refTelefone.current = el; register("telefone_humano").ref(el);}} onClick={() => clearError(refTelefone, refLabelTelefone, refErrorTelefone, error, setError)} onChange={(e) => {if (error === "0") {setValue("telefone_humano", masktelefone(e.target.value));} else {clearError(refTelefone, refLabelTelefone, refErrorTelefone, error, setError);}}}></input>
                                <span className="label">Telefone</span>
                                <span className="focus-bg"></span>
                                </label>
                            </div>
                            <div className="aesthetic_box03b"></div>
                        </div>

                        <span className="space_form"></span>
                        <span className="space_form"></span>
                        <button type="button" name="bt1a" className="button_form" onClick={aesthetic_step1}>AVANÇAR</button>
                    
                    </form>
                </div>                    
                </>
                )}


                { step === 1 &&
                (
                <>
                <div className="ft_topico">Configurar agente</div>
                <div className="ft_descricao">Chegou a hora de configurar seu agente, essa é uma etapa muito importante, aqui você definirá todas as regras para que seu agente possa dar o melhor atendimento a seus clientes.</div>
                <div className="space"></div>

                <div className="border_form aesthetic_border_form">
                    <form className="form">

                        <span className="step_form">
                            <span className="step_form_number">Passo 2/4</span>
                            <span className="step_form_description">&nbsp;. Informações do Profissional</span>
                        </span>

                        <span className="space_form"></span>

                        <span className="title_form">Identificação do(a) esteticista</span>
                        <span className="subtitle_form">Preencha as informações sobre o/a esteticista que irá realizar os atendimentos.</span>
                        <span className="subtitle_form">Quanto mais informações você inserir em informações relevantes, mais completo seu agente ficará.</span>

                        <span className="error_form" ref={refErrorEsteticista}></span>
                        <label for="inp" className="inp" ref={refLabelEsteticista}>
                        <input type="text" placeholder="&nbsp;" maxLength={60} {...register("esteticista")} ref={(el) => {refEsteticista.current = el; register("esteticista").ref(el);}} onClick={() => clearError(refEsteticista, refLabelEsteticista, refErrorEsteticista, error, setError)} onChange={() => clearError(refEsteticista, refLabelEsteticista, refErrorEsteticista, error, setError)}></input>
                        <span className="label">Nome do(a) esteticista</span>
                        <span className="focus-bg"></span>
                        </label>
                        
                        <span className="space_form"></span>

                        <span className="error_form" ref={refErrorInformacao}></span>
                        <label for="inp2" class="inp2" ref={refLabelInformacao}>
                        <textarea placeholder="&nbsp;" {...register("informacao")} maxLength={400} ref={(el) => {refInformacao.current = el; register("informacao").ref(el);}} onClick={() => clearError(refInformacao, refLabelInformacao, refErrorInformacao, error, setError)} onChange={() => clearError(refInformacao, refLabelInformacao, refErrorInformacao, error, setError)}></textarea>
                        <span class="label2">Informações relevantes</span>
                        <span class="focus-bg2"></span>
                        </label>
                            
                        <span className="space_form"></span>

                        <span className="title_form">Cursos e especializações</span>

                        { cursos.length > 0 && (<><span className="subtitle_form">Cursos cadastrados</span></>)}
                        
                        { cursos.map(item => (
                            <>
                            <div className="aesthetic_box">

                                <div className="aesthetic_box04a">
                                    <label for="inp" className="inp">
                                    <input type="text" placeholder="&nbsp;" disabled={true} value={item.curso}></input>
                                    <span className="label">Nome do curso</span>
                                    <span className="focus-bg"></span>
                                    </label>
                                </div>

                                <div className="aesthetic_box04b"></div>

                                <div className="aesthetic_box04c">
                                    <label for="inp" className="inp">
                                    <input type="text" placeholder="&nbsp;" disabled={true} value={item.conclusao}></input>
                                    <span className="label">Conclusão (ano)</span>
                                    <span className="focus-bg"></span>
                                    </label>
                                </div>

                            </div>

                            <span className="space_form"></span>

                            { item.descricao.length > 0 && (
                            <>
                                <label for="inp2" className="inp2">
                                <textarea placeholder="&nbsp;" disabled={true} value={item.descricao}></textarea>
                                <span class="label2">Informações relevantes do curso</span>
                                <span class="focus-bg2"></span>
                                </label>
                                <span className="space_form"></span>
                            </>)}

                            <div className="aesthetic_box">
                                <div className="aesthetic_box05a"></div>
                                <div className="aesthetic_box05b"></div>
                                <div className="aesthetic_box05c">
                                    <button type="button" name="bt3c" className="buttonsearch_form" onClick={() => remove_cursos(item.id)}>REMOVER CURSO</button>
                                </div>
                            </div>

                            <div className="aesthetic_cursos_line"></div>

                            </>)
                        )}

                        <span className="subtitle_form">Insira cursos, treinamentos, formações e especializações que você julgue relevante para que seus pacientes saibam - opcional.</span>

                        <span className="error_form" ref={refErrorCurso}></span>
                        <div className="aesthetic_box">

                            <div className="aesthetic_box04a">
                                <label for="inp" className="inp" ref={refLabelCurso}>
                                <input type="text" placeholder="&nbsp;" maxLength={30} {...register("curso")} ref={(el) => {refCurso.current = el; register("curso").ref(el);}} onClick={() => clearError(refCurso, refLabelCurso, refErrorCurso, error, setError)} onChange={() => clearError(refCurso, refLabelCurso, refErrorCurso, error, setError)}></input>
                                <span className="label">Nome do curso</span>
                                <span className="focus-bg"></span>
                                </label>
                            </div>

                            <div className="aesthetic_box04b"></div>

                            <div className="aesthetic_box04c">
                                <label for="inp" className="inp" ref={refLabelConclusao}>
                                <input type="text" placeholder="&nbsp;" maxLength={4} {...register("conclusao")} ref={(el) => {refConclusao.current = el; register("conclusao").ref(el);}} onClick={() => clearError(refConclusao, refLabelConclusao, refErrorCurso, error, setError)} onChange={() => clearError(refConclusao, refLabelConclusao, refErrorCurso, error, setError)} onKeyDown={(e) => {if (!/[0-9]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Tab') {e.preventDefault();}}}></input>
                                <span className="label">Conclusão (ano)</span>
                                <span className="focus-bg"></span>
                                </label>
                            </div>

                        </div>

                        <span className="space_form"></span>
                        
                        <label for="inp2" className="inp2">
                        <textarea placeholder="&nbsp;" {...register("descricao_curso")} maxLength={200} ref={(el) => {refDescription.current = el; register("descricao_curso").ref(el);}}></textarea>
                        <span class="label2">Informações relevantes do curso</span>
                        <span class="focus-bg2"></span>
                        </label>
                        
                        <span className="space_form"></span>

                        <div className="aesthetic_box">
                            <div className="aesthetic_box05a"></div>
                            <div className="aesthetic_box05b"></div>
                            <div className="aesthetic_box05c">
                                <button type="button" name="bt3c" className="buttonsearch_form" onClick={add_cursos}>ADICIONAR CURSO</button>
                            </div>
                        </div>

                        <span className="space_form"></span>
                        <span className="space_form"></span>
                        
                        <div className="aesthetic_buttons_box">
                            <div className="aesthetic_box06a">
                                <button type="button" name="bt2a" className="button2_form" onClick={(e) => back_step(0)}>VOLTAR</button>
                            </div>
                            <div className="aesthetic_box06b"></div>
                            <div className="aesthetic_box06c">
                                <button type="button" name="bt2b" className="button_form" onClick={aesthetic_step2}>AVANÇAR</button>
                            </div>
                        </div>

                    </form>
                </div>
                </>
                )}


                { step === 2 &&
                (
                <>
                <div className="ft_topico">Configurar agente</div>
                <div className="ft_descricao">Chegou a hora de configurar seu agente, essa é uma etapa muito importante, aqui você definirá todas as regras para que seu agente possa dar o melhor atendimento a seus clientes.</div>
                <div className="space"></div>

                <div className="border_form aesthetic_border_form">
                    <form className="form">

                        <span className="step_form">
                            <span className="step_form_number">Passo 3/4</span>
                            <span className="step_form_description">&nbsp;. Procedimentos</span>
                        </span>

                        <span className="space_form"></span>

                        <span className="title_form">Cadastro de procedimentos</span>
                
                        { procedimentos.length > 0 && (<><span className="subtitle_form">Procedimentos cadastrados</span></>)}
                        
                        { procedimentos.map(item => (
                            <>
                            <div className="aesthetic_box">

                                <div className="aesthetic_box04a">
                                    <label for="inp" className="inp">
                                    <input type="text" placeholder="&nbsp;" disabled={true} value={item.procedimento}></input>
                                    <span className="label">Procedimento</span>
                                    <span className="focus-bg"></span>
                                    </label>
                                </div>

                                <div className="aesthetic_box04b"></div>

                                <div className="aesthetic_box04c">
                                    <label for="inp" className="inp">
                                    <input type="text" placeholder="&nbsp;" disabled={true} value={item.valor.toFixed(2, 0)}></input>
                                    <span className="label">Valor (R$)</span>
                                    <span className="focus-bg"></span>
                                    </label>
                                </div>

                            </div>

                            <span className="space_form"></span>

                            { item.descricao.length > 0 && (
                            <>
                                <label for="inp2" className="inp2">
                                <textarea placeholder="&nbsp;" disabled={true} value={item.descricao}></textarea>
                                <span class="label2">Descrição do procedimento</span>
                                <span class="focus-bg2"></span>
                                </label>
                                <span className="space_form"></span>
                            </>)}

                            <div className="aesthetic_box">
                                <div className="aesthetic_box05a"></div>
                                <div className="aesthetic_box05b"></div>
                                <div className="aesthetic_box05c">
                                    <button type="button" name="bt3c" className="buttonsearch_form" onClick={() => remove_procedimento(item.id)}>REMOVER PROCEDIMENTO</button>
                                </div>
                            </div>

                            <div className="aesthetic_cursos_line"></div>

                            </>)
                        )}

                        <span className="subtitle_form">Cadastre os procedimentos que você realiza para informar ao seus clientes.</span>

                        <span className="error_form" ref={refErrorProcedimentos}></span>
                        <div className="aesthetic_box">

                            <div className="aesthetic_box04a">
                                <label for="inp" className="inp" ref={refLabelProcedimentos}>
                                <input type="text" placeholder="&nbsp;" maxLength={40} {...register("procedimento")} ref={(el) => {refProcedimentos.current = el; register("procedimento").ref(el);}} onClick={() => clearError(refProcedimentos, refLabelProcedimentos, refErrorProcedimentos, error, setError)} onChange={() => clearError(refProcedimentos, refLabelProcedimentos, refErrorProcedimentos, error, setError)}></input>
                                <span className="label">Procedimento</span>
                                <span className="focus-bg"></span>
                                </label>
                            </div>

                            <div className="aesthetic_box04b"></div>

                            <div className="aesthetic_box04c">
                                <label for="inp" className="inp" ref={refLabelValorProcedimentos}>
                                <input type="text" placeholder="&nbsp;" maxLength={10} {...register("valor_procedimento")} ref={(el) => {refValorProcedimentos.current = el; register("valor_procedimento").ref(el);}} onClick={() => clearError(refValorProcedimentos, refLabelValorProcedimentos, refErrorProcedimentos, error, setError)} onChange={() => clearError(refValorProcedimentos, refLabelValorProcedimentos, refErrorProcedimentos, error, setError)} onKeyDown={(e) => {if (!/[0-9,]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Tab') {e.preventDefault();}}}></input>
                                <span className="label">Valor (R$)</span>
                                <span className="focus-bg"></span>
                                </label>
                            </div>

                        </div>

                        <span className="space_form"></span>
                        
                        <span className="error_form" ref={refErrorProcedimentosDescricao}></span>
                        <label for="inp2" className="inp2" ref={refLabelProcedimentosDescricao}>
                        <textarea placeholder="&nbsp;" {...register("descricao_procedimento")} maxLength={200} ref={(el) => {refProcedimentosDescricao.current = el; register("descricao_procedimento").ref(el);}} onClick={() => clearError(refProcedimentosDescricao, refLabelProcedimentosDescricao, refErrorProcedimentosDescricao, error, setError)} onChange={() => clearError(refProcedimentosDescricao, refLabelProcedimentosDescricao, refErrorProcedimentosDescricao, error, setError)}></textarea>
                        <span class="label2">Descrição do procedimento</span>
                        <span class="focus-bg2"></span>
                        </label>
                        
                        <span className="space_form"></span>

                        <div className="aesthetic_box">
                            <div className="aesthetic_box05a"></div>
                            <div className="aesthetic_box05b"></div>
                            <div className="aesthetic_box05c">
                                <button type="button" name="bt3c" className="buttonsearch_form" onClick={add_procedimento}>ADICIONAR PROCEDIMENTO</button>
                            </div>
                        </div>

                        <span className="space_form"></span>
                        <span className="title_form">FAQ - Perguntas e respostas</span>

                        { faq.length > 0 && (<><span className="subtitle_form">FAQs cadastradas</span></>)}
                        
                        { faq.map(item => (
                            <>
                            <label for="inp" className="inp">
                            <input type="text" placeholder="&nbsp;" disabled={true} value={item.pergunta}></input>
                            <span className="label">Pergunta</span>
                            <span className="focus-bg"></span>
                            </label>

                            <span className="space_form"></span>
                                                        
                            <label for="inp" className="inp">
                            <input type="text" placeholder="&nbsp;" disabled={true} value={item.resposta}></input>
                            <span className="label">Resposta</span>
                            <span className="focus-bg"></span>
                            </label>

                            <span className="space_form"></span>
                            <div className="aesthetic_box">
                                <div className="aesthetic_box05a"></div>
                                <div className="aesthetic_box05b"></div>
                                <div className="aesthetic_box05c">
                                    <button type="button" name="bt3d" className="buttonsearch_form" onClick={() => remove_faq(item.id)}>REMOVER FAQ</button>
                                </div>
                            </div>
 
                            <div className="aesthetic_cursos_line"></div>
                            </>)
                        )}

                        <span className="subtitle_form">Você pode melhorar muito a interação de seu agente criando uma biblioteca das perguntas e respostas mais frequentes.</span>
                        <span className="space_form"></span>

                        <span className="error_form" ref={refErrorPergunta}></span>
                        <label for="inp" className="inp" ref={refLabelPergunta}>
                        <input type="text" placeholder="&nbsp;" maxLength={70} {...register("pergunta")} ref={(el) => {refPergunta.current = el; register("pergunta").ref(el);}} onClick={() => clearError(refPergunta, refLabelPergunta, refErrorPergunta, error, setError)} onChange={() => clearError(refPergunta, refLabelPergunta, refErrorPergunta, error, setError)}></input>
                        <span className="label">Pergunta</span>
                        <span className="focus-bg"></span>
                        </label>

                        <span className="space_form"></span>

                        <span className="error_form" ref={refErrorResposta}></span>
                        <label for="inp" className="inp" ref={refLabelResposta}>
                        <input type="text" placeholder="&nbsp;" maxLength={100} {...register("resposta")} ref={(el) => {refResposta.current = el; register("resposta").ref(el);}} onClick={() => clearError(refResposta, refLabelResposta, refErrorResposta, error, setError)} onChange={() => clearError(refResposta, refLabelResposta, refErrorResposta, error, setError)}></input>
                        <span className="label">Resposta</span>
                        <span className="focus-bg"></span>
                        </label>

                        <span className="space_form"></span>

                        <div className="aesthetic_box">
                            <div className="aesthetic_box05a"></div>
                            <div className="aesthetic_box05b"></div>
                            <div className="aesthetic_box05c">
                                <button type="button" name="bt3c" className="buttonsearch_form" onClick={add_faq}>ADICIONAR FAQ</button>
                            </div>
                        </div>

                        <span className="space_form"></span>
                        <span ref={refErroProcedimento} className="error_form"></span>
                        <span className="space_form"></span>

                        <div className="aesthetic_buttons_box">
                            <div className="aesthetic_box06a">
                                <button type="button" name="bt3a" className="button2_form" onClick={(e) => back_step(1)}>VOLTAR</button>
                            </div>
                            <div className="aesthetic_box06b"></div>
                            <div className="aesthetic_box06c">
                                <button type="button" name="bt3b" className="button_form" onClick={aesthetic_step3}>AVANÇAR</button>
                            </div>
                        </div>
                
                    </form>
                </div>
                </>
                )}


                { step === 3 &&
                (
                <>
                <div className="ft_topico">Configurar agente</div>
                <div className="ft_descricao">Chegou a hora de configurar seu agente, essa é uma etapa muito importante, aqui você definirá todas as regras para que seu agente possa dar o melhor atendimento a seus clientes.</div>
                <div className="space"></div>

                <div className="border_form aesthetic_border_form">
                    <form className="form" onSubmit={handleSubmit(configure_agent)}>

                        <span className="step_form">
                            <span className="step_form_number">Passo 4/4</span>
                            <span className="step_form_description">&nbsp;. Agenda</span>
                        </span>

                        <span className="space_form"></span>

                        <span className="title_form">Defina sua agenda diária</span>
                        <span className="subtitle_form">Defina seus dias e horários de disponibilidade para atendimento clicando no dia-horário específico.</span>

                        <span className="error_form" ref={refErrorAgenda}></span>
                        <div className="aesthetic_calendar_frame-desktop">
                            <div className="aesthetic_calendar_column">Segunda</div>
                            <div className="aesthetic_calendar_column">Terça</div>
                            <div className="aesthetic_calendar_column">Quarta</div>
                            <div className="aesthetic_calendar_column">Quinta</div>
                            <div className="aesthetic_calendar_column">Sexta</div>
                            <div className="aesthetic_calendar_column">Sábado</div>
                            <div className="aesthetic_calendar_column">Domingo</div>
                        </div>
                        <div className="aesthetic_calendar_frame-mobile">
                            <div className="aesthetic_calendar_column">Seg</div>
                            <div className="aesthetic_calendar_column">Ter</div>
                            <div className="aesthetic_calendar_column">Qua</div>
                            <div className="aesthetic_calendar_column">Qui</div>
                            <div className="aesthetic_calendar_column">Sex</div>
                            <div className="aesthetic_calendar_column">Sáb</div>
                            <div className="aesthetic_calendar_column">Dom</div>
                        </div>
                        <div className="aesthetic_calendar_frame">
                            {dias.map((dia, dIndex) => (
                                <div className="aesthetic_calendar_column" key={dIndex}>
                                    {dia.map((item, index) => (
                                        <>
                                        <div className="aesthetic_calendar_cell" style={{borderBottom: "dashed 1px var(--PRI_2)", borderTop: item.hora === 0 ? "dashed 1px var(--PRI_2)" : "", backgroundColor: item.disponivel ? "yellow" : "white", color: item.disponivel ? "var(--SEC_2)" : "var(--CNZ_2)", borderTopLeftRadius: dIndex === 0 && index === 0 ? "8px" : "", borderTopRightRadius: dIndex === 6 && index === 0 ? "8px" : "", borderBottomLeftRadius: dIndex === 0 && index === 23 ? "8px" : "", borderBottomRightRadius: dIndex === 6 && index === 23 ? "8px" : ""}} key={item} onClick={() => marcar_agenda(dIndex, item.hora)}>{item.hora === 23 ? "23-00" : String(item.hora) + "-" + String(item.hora + 1)}</div>
                                        </>
                                    ))}
                                </div>
                            ))}

                        </div>

                        <span className="space_form"></span>
                        <span className="title_form">Bloqueie um dia ou período específico</span>

                        { blocks.length > 0 && (<><span className="subtitle_form">Períodos ou dias bloqueados</span></>)}
                        
                        { blocks.map((item, index) => (
                        <>
                            <div className="aesthetic_block_box" style={{borderTop: index === 0 ? "dashed 1px var(--PRI_2)" : "", borderTopRightRadius: index === 0 ? "8px" : "", borderTopLeftRadius: index === 0 ? "8px" : "", borderBottomLeftRadius: blocks.length - 1 === index ? "8px" : "", borderBottomRightRadius: blocks.length - 1 === index ? "8px" : ""}}>
                                <span className="aesthetic_block_text">{item.dia_final === null ? formatTimestamp(item.dia_inicial) + " - " + item.motivo : formatTimestamp(item.dia_inicial) + " a " + formatTimestamp(item.dia_final) + " - " + item.motivo}</span>
                                <span onClick={() => remove_block(item.id)}><img className="aesthetic_block_exclude" src={icon_exclude}></img></span>
                            </div>

                            { blocks.length - 1 === index && (<><span className="space_form"></span></>)}
                        </>)
                        )}

                        <span className="subtitle_form">Ao bloquear um dia ou um período específico, o agente indisponibilizará esse intervalo de tempo a seus pacientes.</span>
                        <span className="aesthetic_observacao">Insira o dia inicial para bloquear apenas um dia ou insira dia inicial e final para um período (formato = dd/mm/aa)</span>
                            
                        <span className="error_form" ref={refErrorDiaInicial}></span>
                        <div className="aesthetic_box">

                            <div className="aesthetic_box07a">
                                <div className="aesthetic_box07a1">
                                    <label for="inp" className="inp" ref={refLabelDiaInicial}>
                                    <input type="text" placeholder="&nbsp;" maxLength={8} {...register("dia_inicial")} ref={(el) => {refDiaInicial.current = el; register("dia_inicial").ref(el);}} onClick={() => clearError(refDiaInicial, refLabelDiaInicial, refErrorDiaInicial, error, setError)} onChange={(e) => {if (error === "0") {setValue("dia_inicial", maskdata(e.target.value));} else {clearError(refDiaInicial, refLabelDiaInicial, refErrorDiaInicial, error, setError);}}}></input>
                                    <span className="label">Dia Inicial</span>
                                    <span className="focus-bg"></span>
                                    </label>
                                </div>
                                <div className="aesthetic_box07a2"></div>
                                <div className="aesthetic_box07a3">
                                    <label for="inp" className="inp" ref={refLabelDiaFinal}>
                                    <input type="text" placeholder="&nbsp;" maxLength={8} {...register("dia_final")} ref={(el) => {refDiaFinal.current = el; register("dia_final").ref(el);}} onClick={() => clearError(refDiaFinal, refLabelDiaFinal, refErrorDiaInicial, error, setError)} onChange={(e) => {if (error === "0") {setValue("dia_final", maskdata(e.target.value));} else {clearError(refDiaFinal, refLabelDiaFinal, refErrorDiaInicial, error, setError);}}}></input>
                                    <span className="label">Dia Final</span>
                                    <span className="focus-bg"></span>
                                    </label>
                                </div>
                            </div>

                            <div className="aesthetic_box07b"></div>

                            <div className="aesthetic_box07c">
                                <label for="inp" className="inp">
                                <input type="text" placeholder="&nbsp;" maxLength={20} {...register("motivo")} ref={(el) => {refMotivo.current = el; register("motivo").ref(el);}} onClick={() => clearError(refMotivo, refLabelMotivo, refErrorDiaInicial, error, setError)} onChange={() => clearError(refMotivo, refLabelMotivo, refErrorDiaInicial, error, setError)}></input>
                                <span className="label">Motivo</span>
                                <span className="focus-bg"></span>
                                </label>
                            </div>
                            <div className="aesthetic_box07b"></div>
                            <div className="aesthetic_box07d">
                                <button type="button" name="bt4c" className="buttonsearch_form" onClick={add_block}>ADICIONAR</button>
                            </div>
                        </div>

                        <span className="space_form"></span>
                        <span ref={refErrorTerms} className="error_form"></span>
                        <div className="aesthetic_terms">
                            <input type="checkbox" className="checkbox_default" ref={refCheckBox} onClick={accept_terms}></input>
                            <span className="aesthetic_terms_text">Estou ciente conforme os termos de uso.</span>
                        </div>

                        <span className="space_form"></span>
                        <span ref={refError} className="error_form"></span>
                        <span className="space_form"></span>

                        <div className="aesthetic_buttons_box">
                            <div className="aesthetic_box06a">
                                <button type="button" name="bt4a" className="button2_form" onClick={ (e) => back_step(2) } disabled={isPending}>VOLTAR</button>
                            </div>
                            <div className="aesthetic_box06b"></div>
                            <div className="aesthetic_box06c">
                                <button type="submit" ref={refButtonConcluir} name="bt4b" className="button_form" disabled={isPending}>CONCLUIR</button>
                            </div>
                        </div>

                    </form>
                </div>
                </>
                )}

                { step === 4 &&
                (
                <>
                <div className="ft_topico">Agente configurado</div>
                <div className="ft_descricao">Parabéns {firstName(user.responsavel)}, você concluiu todas as etapas e seu agente está pronto para ser testado.</div>
                <div className="space"></div>
                <img className="aesthetic_image" src={icon_success}></img>
                <div className="space"></div>
                <span className="aesthetic_success_01">O nome do seu agente é:</span>
                <span className="aesthetic_success_04">{agent.nome}</span>
                <div className="space"></div>
                <span className="aesthetic_success_01">Ele foi configurado na linha telefonica:</span>
                <span className="aesthetic_success_04">{telefone}</span>
                <div className="space"></div>
                <span className="aesthetic_success_01">E a agenda dele foi compartilhada com o email:</span>
                <span className="aesthetic_success_04">{user.email}</span>
                <div className="space"></div>
                <span className="aesthetic_success_03">Para testar e interagir com seu agente, basta dar um "oi" no WhatsApp para o número de telefone em que ele foi configurado.</span>
                <span className="space_form"></span>
                <span className="aesthetic_success_02">Aproveite!<br />Você tem 7 dias gratuítos para testar seu agente</span>
                <div className="space"></div>
                <span className="aesthetic_success_05">Para sincronizar a agenda do seu agente no seu smartphone, preparamos um manual, consulte clicando aqui</span>
                </>
                )}

            <div className="space"></div>
            <div className="space"></div>
            <div className="space"></div>
         
            </div>
        
        <Footer access={1}></Footer>
        
        </div>
    )
}